export default {
  highlighted: {
    title: 'Highlighted',
    theHightlightedListCouldNotBeLoaded: 'The highlighted content could not be loaded'
  }
}
